import { createAPI } from "../apisServer";

import BaseUrl from "../baseUrls";

const banco = BaseUrl.dataBase;
const apiServer = createAPI("multiTenant");

const reqEmpresa = {
	listID: async function () {
		return apiServer
			.get(`portal/v1/empresa/`, {
				headers: {
					banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	listIDConfig: async function (id) {
		return apiServer
			.get(`portal/v1/empresa/config/${id}`, {
				headers: {
					banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	insert: async function (data) {
		return apiServer
			.post("portal/v1/empresa", data, {
				headers: {
					banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	update: async function (data) {
		return apiServer
			.put("portal/v1/empresa", data, {
				headers: {
					banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	patch: async function (data) {
		return apiServer
			.patch("portal/v1/empresa", data, {
				headers: {
					banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	unlock: async function (data) {
		return apiServer
			.patch("portal/v1/empresa/desbloqueio", data, {
				headers: {
					banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	updateDNS: async function (data) {
		return apiServer
			.patch("portal/v1/empresa/dns", data, {
				headers: {
					banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
};

export default reqEmpresa;
